import React, { useEffect } from 'react';
import { useFunnelConfig } from './ThreeJobs';
import { PageCtx, useFunnelContent, pageBg } from './editor/EditableBits';
import { FunnelSections } from './editor/registry';
import { PageWidgets } from './editor/Widgets';
import '../../components/landing/arc/arc.css';

export default function ChallengeThanksPage() {
  const config = useFunnelConfig();
  const pages = useFunnelContent();

  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <PageCtx.Provider value={{ config, handlers: {}, jobs: null }}>
      <div className="min-h-screen arc-bone" style={{ background: pageBg(pages.thanks) || undefined }} data-testid="challenge-thanks-page">
        <FunnelSections sections={pages.thanks} />
        <PageWidgets sections={pages.thanks} />

        <footer className="border-t border-black/[0.06] py-8 text-center mt-4">
          <p className="arc-body text-xs text-[#141414]/40">© {new Date().getFullYear()} Voxinity AI. All rights reserved.</p>
        </footer>
      </div>
    </PageCtx.Provider>
  );
}
